import { AxiosRequestConfig, AxiosResponse } from 'axios';
import {
	CancellationResponse,
	CancellationUpdateRequest,
	ReinstatementResponse,
	ReinstatementUpdateRequest,
} from '../types/cancellations';
import { getApiUrl } from '../util/util';
import { get, patch } from './http';

interface CancellationsApi {
	getCancellationsForPolicy(
		authorizationToken: string,
		policyLocator: string,
		config?: AxiosRequestConfig<any>,
	): Promise<AxiosResponse<CancellationResponse[]>>;
	getCancellation(
		authorizationToken: string,
		cancellationLocator: string,
		config?: AxiosRequestConfig<any>,
	): Promise<AxiosResponse<CancellationResponse>>;
	updateCancellation(
		authorizationToken: string,
		cancellationLocator: string,
		params: CancellationUpdateRequest,
	): Promise<AxiosResponse<CancellationResponse>>;
	rescindCancellation(
		authorizationToken: string,
		cancellationLocator: string,
	): Promise<AxiosResponse<CancellationResponse>>;
	issueCancellation(
		authorizationToken: string,
		cancellationLocator: string,
	): Promise<AxiosResponse<CancellationResponse>>;
	reinstateCancellation(
		authorizationToken: string,
		cancellationLocator: string,
	): Promise<AxiosResponse<CancellationResponse>>;
	updateReinstatement(
		authorizationToken: string,
		cancellationLocator: string,
		params: ReinstatementUpdateRequest,
	): Promise<AxiosResponse<ReinstatementResponse>>;
	acceptReinstatement(
		authorizationToken: string,
		cancellationLocator: string,
	): Promise<AxiosResponse<ReinstatementResponse>>;
	invalidateReinstatement(
		authorizationToken: string,
		cancellationLocator: string,
	): Promise<AxiosResponse<ReinstatementResponse>>;
	issueReinstatement(
		authorizationToken: string,
		cancellationLocator: string,
	): Promise<AxiosResponse<ReinstatementResponse>>;
}

export default {
	getCancellationsForPolicy(
		authorizationToken: string,
		policyLocator: string,
		config?: AxiosRequestConfig<any>,
	) {
		return get(
			`${getApiUrl()}/policies/${policyLocator}/cancellations`,
			authorizationToken,
			config,
		);
	},
	getCancellation(
		authorizationToken: string,
		cancellationLocator: string,
		config?: AxiosRequestConfig<any>,
	) {
		return get(
			`${getApiUrl()}/cancellations/${cancellationLocator}`,
			authorizationToken,
			config,
		);
	},
	updateCancellation(
		authorizationToken: string,
		cancellationLocator: string,
		params: CancellationUpdateRequest,
	) {
		return patch(
			`${getApiUrl()}/cancellations/${cancellationLocator}`,
			authorizationToken,
			params,
		);
	},
	rescindCancellation(authorizationToken: string, cancellationLocator: string) {
		return patch(
			`${getApiUrl()}/cancellations/${cancellationLocator}/rescind`,
			authorizationToken,
		);
	},
	issueCancellation(authorizationToken: string, cancellationLocator: string) {
		return patch(
			`${getApiUrl()}/cancellations/${cancellationLocator}/issue`,
			authorizationToken,
		);
	},
	reinstateCancellation(
		authorizationToken: string,
		cancellationLocator: string,
	) {
		return patch(
			`${getApiUrl()}/cancellations/${cancellationLocator}/reinstate`,
			authorizationToken,
			{},
		);
	},
	updateReinstatement(
		authorizationToken: string,
		reinstatementLocator: string,
		params: ReinstatementUpdateRequest,
	) {
		return patch(
			`${getApiUrl()}/reinstatements/${reinstatementLocator}`,
			authorizationToken,
			params,
		);
	},
	acceptReinstatement(
		authorizationToken: string,
		reinstatementLocator: string,
	) {
		return patch(
			`${getApiUrl()}/reinstatements/${reinstatementLocator}/accept`,
			authorizationToken,
		);
	},
	invalidateReinstatement(
		authorizationToken: string,
		reinstatementLocator: string,
	) {
		return patch(
			`${getApiUrl()}/reinstatements/${reinstatementLocator}/invalidate`,
			authorizationToken,
		);
	},
	issueReinstatement(authorizationToken: string, reinstatementLocator: string) {
		return patch(
			`${getApiUrl()}/reinstatements/${reinstatementLocator}/issue`,
			authorizationToken,
		);
	},
} as CancellationsApi;
